import { Component, OnInit, TemplateRef, trigger, state, style, transition, animate } from '@angular/core';

import { BuyService } from '../services/buyservice'
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(500, style({ opacity: 0 }))
      ])
    ]),
  ],

})
export class AdminComponent implements OnInit {

  hideMenu = true;

  private checkMenuUser = true;
  private checkMenuProduct = true;
  checkNottify;
  constructor(private buy: BuyService) { }

  ngOnInit() {
    this.checkNottify = this.buy.getNottify()
  }
  hideMenuLeft() {
    this.hideMenu = !this.hideMenu;
  }
  toggleUser() {
    this.checkMenuUser = !this.checkMenuUser;
  }
  toggleProduct() {
    this.checkMenuProduct = !this.checkMenuProduct;
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/admin.component.ts